import EVENT from '../enums/event.js';
import dispatchEvent from '../utils/dispatch-event.js';
import onDocumentReady from '../utils/on-document-ready.js';

class QuantitySelector extends HTMLElement {
  constructor() {
    super();

    onDocumentReady(() => {
      this.initEventListeners();
    });
  }

  get decrementButton() {
    return this.querySelector('[data-decrement]');
  }

  get incrementButton() {
    return this.querySelector('[data-increment]');
  }

  get variantId() {
    return this.dataset.variantId;
  }

  get currentQuantity() {
    return Number(this.querySelector('[data-quantity]').innerText);
  }

  get inventory() {
    return this.dataset.lineItemInventory;
  }

  changeQuantity(newQuantity) {
    fetch(`/cart/update.js?updates[${this.variantId}]=${newQuantity}`).then(
      () => {
        dispatchEvent(EVENT.CART.UPDATE, document);
      }
    );
  }

  increment() {
    if (
      this.inventory === 'preorder' ||
      this.inventory > this.currentQuantity
    ) {
      this.changeQuantity(this.currentQuantity + 1);
    }
  }

  decrement() {
    this.changeQuantity(this.currentQuantity - 1);
  }

  initEventListeners() {
    this.decrementButton.addEventListener('click', () => this.decrement());
    this.incrementButton.addEventListener('click', () => this.increment());
  }
}

customElements.define('quantity-selector', QuantitySelector);
